import React, { FC } from 'react';

import { BaseStyleEnums } from '@nhl/nhl-breakaway-ui';

import { useSizeWithThrottle } from '~/core/hooks/useSizeWithThrottle';
import { Wiper } from '~/views/components/wiper/Wiper';

import { MetadataContainer, ShareBarContainer } from '../../styles';

import { SkeletonContainer } from './styles';

const Skeleton: FC = () => {
    const size = useSizeWithThrottle();

    return (
        <>
            <MetadataContainer>
                <SkeletonContainer>
                    <Wiper />
                </SkeletonContainer>
                <SkeletonContainer $isBig>
                    <Wiper />
                </SkeletonContainer>
                {size.width <= BaseStyleEnums.ScreenWidthBreakpoints.medium && (
                    <SkeletonContainer>
                        <Wiper />
                    </SkeletonContainer>
                )}
                <SkeletonContainer>
                    <Wiper />
                </SkeletonContainer>
            </MetadataContainer>
            {size.width > BaseStyleEnums.ScreenWidthBreakpoints.medium && (
                <ShareBarContainer>
                    <SkeletonContainer>
                        <Wiper />
                    </SkeletonContainer>
                </ShareBarContainer>
            )}
        </>
    );
};

export default Skeleton;
